<!-- Alert -->
<fuse-alert
    class="mt-8 top-0 right-0 absolute z-99"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

<!-------------------------------------------------------------->
<!---------------------- Skeleton loader ----------------------->
<!-------------------------------------------------------------->

<div *ngIf="loading">

    <div class=" flex-col w-full justify-center items-center">
        <div class="w-full md:w-1/2">
            <ngx-skeleton-loader
                [theme]="{ 
                    'border-radius': '15px',
                    height: '600px'
                }"
            ></ngx-skeleton-loader>
        </div>
    </div>
</div>


<div *ngIf="!loading">
    <div class="flex flex-col py-4 w-full justify-center items-center">

        <div class="mb-8">
            <div class="font-extrabold text-xl">
                Please create your account password
            </div>
            <div class="py-2 text-black text-lg">
                A shiny new Supersonic account has been pre-set up for you. We just need you to create your Supersonic account password below and then you’re one step closer to a super fast connection!
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <fuse-card class="flex flex-col shadow-xl p-5 rounded-2xl">

                <!-- Username -->
                <div class="flex flex-row pb-2 text-black font-extrabold">
                    Username
                </div>
                <div class="flex flex-row mb-8">
                    <div class="border-1 border-primary p-2 rounded-lg w-full">
                        <input class="w-full" matInput #usernameInput placeholder="Promo code" [(ngModel)]="userName" disabled>
                    </div>
                </div>
                
                <!-- Password -->
                <div class="flex flex-row pb-2 text-black font-extrabold">
                    Password
                </div>
                <div class="flex flex-row">
                    <div class="border-1 border-primary p-2 rounded-lg w-full flex justify-between items-center">
                        <input class="w-full" matInput #passwordField placeholder="Password" [(ngModel)]="password" type="password" (keyup)="onPasswordChange($event)">
                        <button
                            mat-icon-button
                            type="button"
                            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                            matSuffix>

                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>

                        </button>
                    </div>
                </div>
                <div *ngIf="!passwordIsValid" class="text-warn-500 mt-4">
                    Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.
                </div>
            </fuse-card>
        </div>
    </div>
</div>

